import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import compose from 'recompose/compose'
import {withStyles} from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import NativeSelect from '@material-ui/core/NativeSelect'
import Input from '@material-ui/core/Input'
import AccountCircle from '@material-ui/icons/AccountCircle'
import CalendarToday from '@material-ui/icons/CalendarToday'
import Phone from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'
import InputAdornment from '@material-ui/core/InputAdornment'
import MaskedInput from 'react-text-mask'
import {withTranslate} from 'react-redux-multilingual'
import Place from '@material-ui/icons/Place'
import LocationCity from '@material-ui/icons/LocationCity'
import States from '../modules/states'
import Cities from '../modules/cities'

class BookingInfoBasic extends React.Component {
  state = {
    fields: [],
    gender: -1,
    city: -1,
    stateList: [],
    cityList: [],
    fieldLoaded: false
  }

  constructor(props) {
    super(props)

    this.onFocus = this.onFocus.bind(this)
    this.DateFormatCustom = this.DateFormatCustom.bind(this)
    this.phoneRef = this.updateRef.bind(this, 'phone')
    this.birthDateRef = this.updateRef.bind(this, 'birthdate')
    this.nameRef = this.updateRef.bind(this, 'name')
    this.lastNameRef = this.updateRef.bind(this, 'lastName')
    this.emailRef = this.updateRef.bind(this, 'email')
    this.documentRef = this.updateRef.bind(this, 'document')
    this.taxIdRef = this.updateRef.bind(this, 'tax_id')
    this.addressRef = this.updateRef.bind(this, 'address')
    this.numberRef = this.updateRef.bind(this, 'number')
    this.complementRef = this.updateRef.bind(this, 'complement')
    this.neighborhoodRef = this.updateRef.bind(this, 'neighborhood')
    this.postalCodeRef = this.updateRef.bind(this, 'postalCode')
  }

  componentDidMount() {
    this.loadDefaultData()
    this.loadSelectedCEP().then(() => {})

    this.setState({
      gender: this.props.checkin.gender,
      city: this.props.checkin.city
    })
  }

  // Returns the field config object for a given field name
  getFieldConfig = (fieldName) =>
    this.props.checkinFieldsBehaviour.find(e => e.field === fieldName) || {}

  eraseStateList = () => {
    this.setState({ stateList: [] })
  }

  eraseCityList = () => {
    this.setState({ cityList: [] })
  }

  handleSelectedGender = (event) => {
    this.props.checkin.gender = event.target.value
    this.setState({ gender: this.props.checkin.gender })
  }

  handleSelectedCity = (event) => {
    this.props.checkin.city = event.target.value
    this.setState({ city: this.props.checkin.city })
  }

  countryChangeHandler = async (event) => {
    this.eraseStateList()
    this.eraseCityList()

    const selectedCountry = event.target.value
    const countryStates = await States.getCountryStates(selectedCountry)

    if (countryStates) {
      this.props.checkin.country = selectedCountry
      this.setState({ stateList: countryStates.result.states })
    }
  }

  countryStateChangeHandler = async (event) => {
    this.eraseCityList()

    const selectedState = event.target.value
    const cities = await Cities.getCities(selectedState)

    if (cities) {
      this.props.checkin.state = selectedState
      this.setState({ cityList: cities.result.cities })
    }
  }

  loadSelectedCEP = async () => {
    if (this.props.checkin.country > 0) {
      const countryStates = await States.getCountryStates(this.props.checkin.country)
      if (countryStates) {
        this.setState({ stateList: countryStates.result.states })
      }
    }
    if (this.props.checkin.state > 0) {
      const cities = await Cities.getCities(this.props.checkin.state)
      if (cities) {
        this.setState({ cityList: cities.result.cities })
      }
    }
  }

  render() {
    const { classes, translate } = this.props
    const f = this.getFieldConfig

    return (
      <>
        <Grid container>
          <Grid container className={classes.gridItemClasses}>
            {f('name').visible && (
              <Grid item xs={12} sm={6} className={classes.gridItemClassesPad}>
                <TextField
                  inputRef={this.nameRef}
                  autoFocus
                  id="firstName"
                  name="firstName"
                  label={translate('firstNameLabel')}
                  value={this.props.checkin.name || ''}
                  onChange={this.props.handleChangeTF('name')}
                  fullWidth
                  autoComplete="fname"
                  required={f('name').required}
                  error={f('name').required && this.props.valid === false && this.props.checkin.name === ''}
                  helperText={
                    f('name').required && !this.props.valid && this.props.checkin.name === ''
                      ? translate('firstNameHelperText')
                      : ''
                  }
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><AccountCircle /></InputAdornment>,
                    maxLength: 50
                  }}
                />
              </Grid>
            )}

            {f('surname').visible && (
              <Grid item xs={12} sm={6}>
                <TextField
                  inputRef={this.lastNameRef}
                  id="lastName"
                  name="lastName"
                  label={translate('lastNameLabel')}
                  value={this.props.checkin.surname || ''}
                  onChange={this.props.handleChangeTF('surname')}
                  className={classes.inputField}
                  fullWidth
                  autoComplete="lname"
                  required={f('surname').required}
                  error={f('surname').required && this.props.valid === false && this.props.checkin.surname === ''}
                  helperText={
                    f('surname').required && !this.props.valid && this.props.checkin.surname === ''
                      ? translate('lastNameHelperText')
                      : ''
                  }
                  InputProps={{
                    startAdornment: <InputAdornment position="start"><AccountCircle /></InputAdornment>,
                    maxLength: 50
                  }}
                />
              </Grid>
            )}
          </Grid>

          {f('email').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.emailRef}
                id="email"
                name="email"
                label={translate('emailLabel')}
                value={this.props.checkin.email || ''}
                onChange={this.props.handleChangeTF('email')}
                fullWidth
                autoComplete="email"
                required={f('email').required}
                error={f('email').required && this.props.validEmail}
                helperText={f('email').required && this.props.validEmail ? translate('emailHelperText') : ''}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><EmailIcon /></InputAdornment>,
                  maxLength: 50
                }}
              />
            </Grid>
          )}

          {f('phone').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.phoneRef}
                id="phone"
                name="phone"
                label={translate('telephoneLabel')}
                value={this.props.checkin.phone || ''}
                onChange={this.props.handleChangeTF('phone')}
                fullWidth
                autoComplete="telf"
                required={f('phone').required}
                error={f('phone').required && this.props.valid === false && this.props.checkin.phone === ''}
                helperText={
                  f('phone').required && !this.props.valid && this.props.checkin.phone === ''
                    ? translate('telephoneHelperText')
                    : ''
                }
                InputProps={{
                  startAdornment: <InputAdornment position="start"><Phone /></InputAdornment>,
                  maxLength: 20
                }}
              />
            </Grid>
          )}

          {f('document').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.documentRef}
                id="iddoc"
                name="iddoc"
                label={translate('documentLabel')}
                value={this.props.checkin.document || ''}
                onChange={this.props.handleChangeTF('document')}
                fullWidth
                required={f('document').required}
                error={f('document').required && this.props.validDocument}
                helperText={f('document').required && this.props.validDocument ? translate('documentHelperText') : ''}
                autoComplete="iddoc"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><AccountCircle /></InputAdornment>,
                  maxLength: 20
                }}
              />
            </Grid>
          )}

          {f('tax_id').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.taxIdRef}
                id="tax_id"
                name="tax_id"
                label={translate('taxIdLabel')}
                value={this.props.checkin.tax_id || ''}
                onChange={this.props.handleChangeTF('tax_id')}
                fullWidth
                required={f('tax_id').required}
                error={
                  f('tax_id').required &&
                  this.props.valid === false &&
                  (this.props.checkin.tax_id === '' || this.props.checkin.tax_id === undefined)
                }
                helperText={
                  f('tax_id').required && !this.props.valid &&
                  (this.props.checkin.tax_id === '' || this.props.checkin.tax_id === undefined)
                    ? translate('taxIdHelperText')
                    : ''
                }
                autoComplete="tax_id"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><AccountCircle /></InputAdornment>,
                  maxLength: 20
                }}
              />
            </Grid>
          )}

          {f('date_of_birth').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.birthDateRef}
                id="dateinput"
                name="dateinput"
                placeholder="dd/MM/yyyy"
                onFocus={this.onFocus}
                label={translate('dateinputLabel')}
                value={this.props.checkin.birth_date || ''}
                onChange={this.props.handleChangeTF('birth_date')}
                fullWidth
                autoComplete="dateinput"
                required={f('date_of_birth').required}
                error={f('date_of_birth').required && this.props.validDateBirth}
                helperText={
                  f('date_of_birth').required && this.props.validDateBirth
                    ? translate('dateinputHelperText')
                    : ''
                }
                InputProps={{
                  startAdornment: <InputAdornment position="start"><CalendarToday /></InputAdornment>,
                  inputComponent: this.DateFormatCustom
                }}
              />
            </Grid>
          )}

          {f('gender').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <NativeSelect
                name="gender"
                fullWidth
                value={this.state.gender}
                onChange={this.handleSelectedGender}
                input={<Input name="genderph" id="gender-label-placeholder" />}
                required={f('gender').required}
                error={f('gender').required && this.props.valid === false && this.props.checkin.gender < 0}
                inputProps={{ id: 'gender-required', style: { height: 35 } }}
              >
                <option value="-1" disabled>{translate('genderLabel')}</option>
                {this.props.genders.map((gender, index) => (
                  <option value={gender.id} key={index}>{gender.name}</option>
                ))}
              </NativeSelect>
              <FormHelperText>
                {f('gender').required && !this.props.valid && this.props.checkin.gender < 0
                  ? translate('genderHelperText')
                  : ''}
              </FormHelperText>
            </Grid>
          )}

          {f('address').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.addressRef}
                id="address"
                name="address"
                label={translate('addressLabel')}
                value={this.props.checkin.address || ''}
                required={f('address').required}
                error={f('address').required && this.props.valid === false && this.props.checkin.address === ''}
                helperText={
                  f('address').required && !this.props.valid && this.props.checkin.address === ''
                    ? translate('addressHelperText')
                    : ''
                }
                onChange={this.props.handleChangeTF('address')}
                className={classes.inputField}
                fullWidth
                autoComplete="address"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><LocationCity /></InputAdornment>,
                  maxLength: 50
                }}
              />
            </Grid>
          )}

          {f('number').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.numberRef}
                id="number"
                name="number"
                label={translate('numberLabel')}
                value={this.props.checkin.number || ''}
                required={f('number').required}
                error={f('number').required && this.props.valid === false && this.props.checkin.number === ''}
                helperText={
                  f('number').required && !this.props.valid && this.props.checkin.number === ''
                    ? translate('numberHelperText')
                    : ''
                }
                onChange={this.props.handleChangeTF('number')}
                className={classes.inputField}
                fullWidth
                autoComplete="number"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><LocationCity /></InputAdornment>,
                  maxLength: 5
                }}
              />
            </Grid>
          )}

          {f('complement').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.complementRef}
                id="complement"
                name="complement"
                label={translate('complementLabel')}
                value={this.props.checkin.complement || ''}
                required={f('complement').required}
                error={f('complement').required && this.props.valid === false && this.props.checkin.complement === ''}
                helperText={
                  f('complement').required && !this.props.valid && this.props.checkin.complement === ''
                    ? translate('complementHelperText')
                    : ''
                }
                onChange={this.props.handleChangeTF('complement')}
                className={classes.inputField}
                fullWidth
                autoComplete="complement"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><LocationCity /></InputAdornment>,
                  maxLength: 5
                }}
              />
            </Grid>
          )}

          {f('neighborhood').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.neighborhoodRef}
                id="neighborhood"
                name="neighborhood"
                label={translate('neighborhoodLabel')}
                value={this.props.checkin.neighborhood || ''}
                required={f('neighborhood').required}
                error={f('neighborhood').required && this.props.valid === false && this.props.checkin.neighborhood === ''}
                helperText={
                  f('neighborhood').required && !this.props.valid && this.props.checkin.neighborhood === ''
                    ? translate('neighborhoodHelperText')
                    : ''
                }
                onChange={this.props.handleChangeTF('neighborhood')}
                className={classes.inputField}
                fullWidth
                autoComplete="neighborhood"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><LocationCity /></InputAdornment>,
                  maxLength: 5
                }}
              />
            </Grid>
          )}

          {f('post_code').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <TextField
                inputRef={this.postalCodeRef}
                id="postalCode"
                name="postalCode"
                label={translate('postalCodeLabel')}
                value={this.props.checkin.postal_code || ''}
                required={f('post_code').required}
                error={f('post_code').required && this.props.valid === false && this.props.checkin.postal_code === ''}
                helperText={
                  f('post_code').required && !this.props.valid && this.props.checkin.postal_code === ''
                    ? translate('postalCodeHelperText')
                    : ''
                }
                onChange={this.props.handleChangeTF('postal_code')}
                className={classes.inputField}
                fullWidth
                autoComplete="postalCode"
                InputProps={{
                  startAdornment: <InputAdornment position="start"><Place /></InputAdornment>,
                  maxLength: 50
                }}
              />
            </Grid>
          )}

          {f('country').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <FormControl
                fullWidth
                className={classes.inputField}
                required={f('country').required}
                error={f('country').required && this.props.valid === false && this.props.checkin.country < 0}
              >
                <InputLabel htmlFor="country-required">{translate('countryLabel')}</InputLabel>
                <NativeSelect
                  name="country"
                  value={this.props.checkin.country}
                  onChange={this.countryChangeHandler}
                  inputProps={{ id: 'country-required' }}
                >
                  <option value="-1" disabled></option>
                  {this.props.countries.map((country, index) => (
                    <option value={country.id} key={index}>{country.name}</option>
                  ))}
                </NativeSelect>
                <FormHelperText>
                  {f('country').required && !this.props.valid && (this.props.checkin.country === null || this.props.checkin.country < 0)
                    ? translate('countryHelperText')
                    : ''}
                </FormHelperText>
              </FormControl>
            </Grid>
          )}

          {f('state').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <NativeSelect
                name="state"
                fullWidth
                value={this.props.checkin.state}
                onChange={this.countryStateChangeHandler}
                input={<Input name="stateph" id="state-label-placeholder" />}
                required={f('state').required}
                error={f('state').required && this.props.valid === false && this.props.checkin.state < 0}
                inputProps={{ id: 'state-required', style: { height: 35 } }}
              >
                <option value="-1" disabled>{translate('stateLabel')}</option>
                {this.state.stateList.map((countryState, index) => (
                  <option value={countryState.id} key={index}>{countryState.name}</option>
                ))}
              </NativeSelect>
              <FormHelperText>
                {f('state').required && !this.props.valid && (this.props.checkin.state === null || this.props.checkin.state < 0)
                  ? translate('stateHelperText')
                  : ''}
              </FormHelperText>
            </Grid>
          )}

          {f('city').visible && (
            <Grid item className={classes.gridItemClasses} xs={12} sm={6}>
              <NativeSelect
                name="city"
                fullWidth
                value={this.state.city}
                onChange={this.handleSelectedCity}
                input={<Input name="stateph" id="city-label-placeholder" />}
                required={f('city').required}
                error={f('city').required && this.props.valid === false && this.props.checkin.city < 0}
                inputProps={{ id: 'city-required', style: { height: 35 } }}
              >
                <option value="-1" disabled>{translate('cityLabel')}</option>
                {this.state.cityList.map((city, index) => (
                  <option value={city.id} key={index}>{city.name}</option>
                ))}
              </NativeSelect>
              <FormHelperText>
                {f('city').required && !this.props.valid && (this.props.checkin.city === null || this.props.checkin.city < 0)
                  ? translate('cityHelperText')
                  : ''}
              </FormHelperText>
            </Grid>
          )}
        </Grid>
      </>
    )
  }

  loadDefaultData() {
    const load =
      process.env.hasOwnProperty('REACT_APP_GUEST_LOAD_DEFAULT_DATA') &&
      process.env.REACT_APP_GUEST_LOAD_DEFAULT_DATA.toString().toLowerCase() === 'yes'

    if (!load) return

    const env = process.env
    this.props.checkin.name        = env.REACT_APP_GUEST_NAME          || ''
    this.props.checkin.surname     = env.REACT_APP_GUEST_SURNAME        || ''
    this.props.checkin.email       = env.REACT_APP_GUEST_EMAIL          || ''
    this.props.checkin.phone       = env.REACT_APP_GUEST_PHONE_NUMBER   || ''
    this.props.checkin.document    = env.REACT_APP_GUEST_DOCUMENT       || ''
    this.props.checkin.tax_id      = env.REACT_APP_GUEST_TAX_ID         || ''
    this.props.checkin.birth_date  = env.REACT_APP_GUEST_BIRTH_DATE     || ''
    this.props.checkin.gender      = env.REACT_APP_GUEST_GENDER         || ''
    this.props.checkin.address     = env.REACT_APP_GUEST_ADDRESS        || ''
    this.props.checkin.number      = env.REACT_APP_GUEST_NUMBER         || ''
    this.props.checkin.complement  = env.REACT_APP_GUEST_COMPLEMENT     || ''
    this.props.checkin.neighborhood= env.REACT_APP_GUEST_NEIGHBORHOOD   || ''
    this.props.checkin.country     = env.REACT_APP_GUEST_COUNTRY        || ''
    this.props.checkin.city        = env.REACT_APP_GUEST_CITY           || ''
    this.props.checkin.state       = env.REACT_APP_GUEST_STATE          || ''
    this.props.checkin.postal_code = env.REACT_APP_GUEST_ZIPCODE        || ''
  }

  updateRef(name, ref) {
    this[name] = ref
  }

  onFocus() {
    if (this.props.birthdate === '') {
      this.birthdate.selectionStart = 0
      this.birthdate.selectionEnd = 0
    }
  }

  DateFormatCustom(props) {
    const { inputRef, ...other } = props
    return (
      <MaskedInput
        {...other}
        mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null)
        }}
        placeholder={this.props.translate('dateformat')}
        placeholderChar={'\u2000'}
      />
    )
  }
}

const styles = (theme) => ({
  DateFormatInput: {
    '& div div': {
      height: '31px'
    }
  },
  cssUnderline: {
    '&:after': {
      borderBottomColor: '#f2994a'
    }
  },
  heading: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(18),
    width: '100%',
    paddingTop: '12px',
    paddingLeft: '12px'
  },
  inputField: {
    marginTop: 15
  },
  gridItemClassesPad: {
    paddingTop: 15
  },
  gridItemClasses: {
    paddingTop: 15,
    paddingBottom: 15
  }
})

BookingInfoBasic.propTypes = {
  classes: PropTypes.object.isRequired
}

export default compose(
  withStyles(styles),
  connect()
)(withTranslate(BookingInfoBasic))
